import BaseLayer from 'ol/layer/Base'
import Map from 'ol/Map'
import View from 'ol/View'
import { useEffect, useRef, useState } from 'react'
import { DEFAULT_LAYERS, DEFAULT_ZOOM_LEVEL, INITIAL_POS } from './map.constants'

const useMap = () => {

  const [map, setMap] = useState<Map>()
  const [view, setView] = useState<View>(new View({
    center: INITIAL_POS,
    zoom: DEFAULT_ZOOM_LEVEL,
  }))
  const [layers, setLayers] = useState<BaseLayer[]>(DEFAULT_LAYERS)

  const ref = useRef<HTMLDivElement>(null)

  // Create a map if we have a ref and don't already have a map
  useEffect(() => {
    if (!map && ref.current) {
      const map = new Map({
        target: ref.current,
      })

      setMap(map)
    }
    return () => {
      if (map) {
        map.dispose()
        setMap(undefined)
      }
    }
  }, [map])

  useEffect(() => {
    if (map) {
      map.setView(view)
    }
  }, [map, view])

  useEffect(() => {
    if (map) {
      map.setLayers(layers)
    }
  }, [map, layers])

  return {
    map,
    ref,
    view,
    setView,
    layers,
    setLayers,
  }
}

export { useMap }